// import Cookies from "js-cookie";
// import { getDataFromCookie } from "../functions/utils";

// export const env_config = (key) => {
//     let value = process.env[key] || "";
//     if (!value) {
//         console.warn(`Missing environment variable: ${key}`);
//     }
//     return value
// };

// export const VERSION = env_config("REACT_APP_VERSION") ||"***" //Update version on each commit  [client pass, module completed, minor fix]
export const VERSION = "1.1.2";

// export const wbsprotocol = 'ws://'
// export const host = "35.154.91.133";

// export const protocol = 'http://'
// export const protocol = window.location.protocol+'//';

export const protocol = "https://";
// export const protocol = 'http://'

export const getHost = () => {
  let host = window.location.host;
  return "franchise.goshweet.com";
  // return "127.0.0.1:8000"

  // if (host === "jaysmetal-admin.web.app" ) {
  //     return env_config("REACT_APP_LIVE_DOMAIN")
  // }
  // else if(host === "localhost:3000"){
  //     // return "api-sandbox.getmebab.com"

  //     // return  "localhost";
  //     // return  "127.0.0.1:8000";
  //     // return  "192.168.1.3:8001";
  //     return  "sandbox.jaysmetal.com";
  //     // return  env_config("REACT_APP_DEV_DOMAIN")
  // }
  // else{
  //     return env_config("REACT_APP_SANDBOX_DOMAIN")
  // }
};

export const url = protocol + getHost();

// export const localStorageName = env_config("REACT_APP_LOCAL_STORAGE")

// // export const cookies_data = JSON.parse( Cookies.get(localStorageName) || "{}" );
// export const cookies_data = getDataFromCookie(localStorageName)

// export const token = cookies_data.token || "";

// if (!token) {
//     // Redirect to login if not authenticated
//     // navigate("/auth/sign-in");
//     if (window.location.pathname !== "/auth/sign-in"){
//         window.location.href = "/auth/sign-in";
//     }
//   }

// export const user_id = cookies_data ? cookies_data.user_id : "";

// export const BUSINESS_NAME = env_config("REACT_APP_BUSINESS_NAME")

// export const FIREBASE_API_KEY=env_config("REACT_APP_FIREBASE_API_KEY")

// export const FIREBASE_PRIVATE_KEY=env_config("REACT_APP_FIREBASE_PRIVATE_KEY")

// export const VERSION = "0.0.3"
